<template>
	<div class="card main">
		<nav>
			<div class="nav-wrapper indigo darken-3">
				<a href="#" class="brand-logo center">Введите_код_из_SMS</a>
			</div>
		</nav>
		<div class="card-content">
			<form class="row" @submit.prevent="submit">
				<div class="input-field col s12">
					<input type="text"
					       id="autocomplete-login"
					       v-model="code"
					       autocomplete="off"
					       class="autocomplete">
					<label for="autocomplete-login">
						Code
					</label>
				</div>
				<button class="waves-effect waves-light btn right indigo darken-3">отправить</button>
			</form>
		</div>
	</div>
</template>
<script>
	import { mapMutations } from "vuex";
	import confirmPhone     from "../../plugins/controllers/confirmPhone";

	export default {
		name:    "verificateCode",
		data() {
			return {
				code: ""
			};
		},
		methods: {
			...mapMutations(["setMenu", "setAuth", "setShowMenu", "setShowVerificateCode"]),
			submit() {
				if (this.code !== "") {
					confirmPhone(this.code)
						.then(res => {
							if (res.data && res.data.success) {
								this.setShowVerificateCode(false);
								this.setAuth(true);
								this.$toast.success({
									title:   "Вы успешно подтвердили ваш номер",
									message: `Заново войдите с вашими учетными данными`,
									timeOut: 7000
								});
							} else if (res.data && !res.data.success) {
								this.setShowVerificateCode(false);
								this.setAuth(true);
								this.$toast.error({
									title:   "Вы ввели не верный код подтверждения",
									message: `Повторите процесс верификации заново`
								});
							}

						})
						.catch(e => {
								console.log(e);
								this.setShowVerificateCode(false);
								this.setAuth(true);
								this.$toast.error({
									title:   "Произошла ошибка",
									message: `Время подтверждения истекло`
								});
							}
						);
				} else {
					return null
				}
			}
		}
	};
</script>
<style scoped lang="scss">
	.brand-logo {
		font-size: 22px;
	}
	form {
		margin: 0;
	}
	.main {
		position: absolute;
		top: 30%;
		left: 50%;
		transform: translateX(-50%);
		width: 98%;
		overflow: hidden;
	}
	@media screen and (min-width: 550px) {
		.main {
			width: 400px;
		}
	}
	@media screen and (min-width: 1200px) {
		.main {
			width: 600px;
		}
	}
</style>
